module.exports = __webpack_public_path__ + "img/events.f30eb51d.svg";